import { IntralinksAccountInfo } from '../../tamalelibs/models/intralinks.model';

export class IntralinksAccountDialogOpenParam {
    operation: IntralinksAccountDialogOperations;
    data?: IntralinksAccountInfo;
    screenId?: string;
}

export enum IntralinksAccountDialogOperations {
    CREATE = 'CREATE',
    EDIT = 'EDIT'
}
